import { useEffect, useState } from "react";

const TypewriterText = () => {
  const words = [
    "Frontend Web Development",
     "Agile Methodology",
    "API Integration",
    "Team Collaboration",
  ]; // Array of words to display

  const [currentWordIndex, setCurrentWordIndex] = useState(0); // Tracks the current word
  const [displayedText, setDisplayedText] = useState(""); // The text currently displayed
  const [isDeleting, setIsDeleting] = useState(false); // Whether the cursor is deleting
  const [speed, setSpeed] = useState(60); // Typing/deleting speed (ms)

  useEffect(() => {
    const currentWord = words[currentWordIndex];

    const handleTyping = () => {
      if (isDeleting) {
        // Deleting letters
        setDisplayedText((prev) => prev.slice(0, -1));
        if (displayedText === "") {
          setIsDeleting(false);
          setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length); // Move to the next word
          setSpeed(150); // Slow down before typing starts
        }
      } else {
        // Typing letters
        setDisplayedText((prev) => currentWord.slice(0, prev.length + 1));
        if (displayedText === currentWord) {
          setIsDeleting(true);
          setSpeed(75); // Speed up while deleting
        }
      }
    };

    const timer = setTimeout(handleTyping, speed); // Typing effect interval

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [displayedText, isDeleting, words, currentWordIndex, speed]);

  return (
    <span style={{ display: "block" }}>
      <span className="text-[#b54a73]">I am in ❤ with</span>{" "}
      <span className="animated-text">
        {displayedText}
        <span className="cursor text-gray-300">|</span>
      </span>
    </span>
  );
};

export default TypewriterText;
